import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var coolToTouchIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 1.5a.75.75 0 0 1 .75.75v1.439l.513-.512a.999.999 0 0 1 1.414 0l.353.353-2.28 2.281V10.7l4.235-2.444.835-3.115.482.129c.534.144.85.692.707 1.226l-.187.7 1.246-.72a.75.75 0 1 1 .75 1.299l-1.246.72.7.187a1 1 0 0 1 .707 1.225l-.129.483-3.115-.835-4.236 2.444 4.236 2.447 3.115-.835.13.483a1 1 0 0 1-.708 1.225l-.7.187 1.246.72a.75.75 0 0 1-.75 1.299l-1.246-.72.188.7a1.001 1.001 0 0 1-.707 1.225l-.483.13-.835-3.115-4.235-2.446v4.89l2.28 2.281-.353.353a.999.999 0 0 1-1.414 0l-.513-.512v1.439a.75.75 0 0 1-1.5 0v-1.439l-.513.512a.999.999 0 0 1-1.414 0l-.353-.353 2.28-2.281v-4.891l-4.236 2.447-.834 3.115-.483-.13a1 1 0 0 1-.707-1.225l.187-.7-1.246.72a.75.75 0 0 1-.75-1.3l1.246-.72-.7-.186a1.001 1.001 0 0 1-.707-1.225l.13-.483 3.114.835 4.235-2.447-4.235-2.444-3.114.835-.13-.483a1 1 0 0 1 .707-1.225l.701-.187-1.247-.72a.751.751 0 0 1 .75-1.3l1.247.72-.188-.7a1.002 1.002 0 0 1 .707-1.225l.483-.13.834 3.116L11.25 10.7V5.81L8.97 3.53l.353-.353a.999.999 0 0 1 1.414 0l.513.512V2.25A.75.75 0 0 1 12 1.5Z",
  fill: "currentColor"
}));

export { coolToTouchIcon as default };
//# sourceMappingURL=coolToTouchIcon.js.map
